  // Flipbook logic
    const pages = document.querySelectorAll('.page');
    const totalPages = pages.length;
    let currentPage = 0;

    function calculateScale() {
        const vh = window.innerHeight - 80; // nav height
        const vw = window.innerWidth;
        const pageW = 210 * 3.7795; // mm to px
        const pageH = 297 * 3.7795;
        const scaleW = (vw - 40) / pageW;
        const scaleH = (vh - 40) / pageH;
        return Math.min(scaleW, scaleH, 1);
    }

    function updateScale() {
        const scale = calculateScale();
        document.documentElement.style.setProperty('--page-scale', scale);
    }

    function showPage(index) {
        if (index < 0 || index >= totalPages) return;
        currentPage = index;
        
        pages.forEach((page, i) => {
            page.classList.remove('active', 'prev', 'next', 'hidden');
            if (i === index) {
                page.classList.add('active');
            } else if (i === index - 1) {
                page.classList.add('prev');
            } else if (i === index + 1) {
                page.classList.add('next');
            } else {
                page.classList.add('hidden');
            }
        });

        // Update controls
        document.getElementById('pageSlider').value = index + 1;
        document.getElementById('pageInfo').textContent = `${index + 1} / ${totalPages}`;
        document.getElementById('btnPrev').disabled = index === 0;
        document.getElementById('btnFirst').disabled = index === 0;
        document.getElementById('btnNext').disabled = index === totalPages - 1;
        document.getElementById('btnLast').disabled = index === totalPages - 1;

        // Update thumbnails
        document.querySelectorAll('.thumbnail-item').forEach((t, i) => {
            t.classList.toggle('active', i === index);
        });
    }

    function nextPage() {
        if (currentPage < totalPages - 1) showPage(currentPage + 1);
    }

    function prevPage() {
        if (currentPage > 0) showPage(currentPage - 1);
    }

    function goToPage(num) {
        showPage(num - 1);
    }

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            nextPage();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            prevPage();
        } else if (e.key === 'Home') {
            e.preventDefault();
            showPage(0);
        } else if (e.key === 'End') {
            e.preventDefault();
            showPage(totalPages - 1);
        }
    });

    // Touch/swipe support
    let touchStartX = 0;
    let touchStartY = 0;
    document.getElementById('viewport').addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
    });
    document.getElementById('viewport').addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - touchStartX;
        const dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
            if (dx < 0) nextPage();
            else prevPage();
        }
    });

    // Thumbnails
    function buildThumbnails() {
        const grid = document.getElementById('thumbnailGrid');
        grid.innerHTML = '';
        pages.forEach((page, i) => {
            const item = document.createElement('div');
            item.className = 'thumbnail-item' + (i === currentPage ? ' active' : '');
            let label = 'Page ' + (i + 1);
            if (page.classList.contains('cover-page')) label = 'Cover';
            else if (page.classList.contains('toc-page')) label = 'Contents';
            else if (page.classList.contains('divider-page')) {
                const title = page.querySelector('.divider-title');
                if (title) label = title.textContent;
            } else if (page.classList.contains('product-page')) {
                const col = page.getAttribute('data-collection');
                if (col) label = col;
            }
            item.innerHTML = `<div class="thumb-num">${i + 1}</div><div class="thumb-label">${label}</div>`;
            item.onclick = () => { showPage(i); toggleThumbnails(); };
            grid.appendChild(item);
        });
    }

    function toggleThumbnails() {
        const panel = document.getElementById('thumbnailPanel');
        if (panel.classList.contains('open')) {
            panel.classList.remove('open');
        } else {
            buildThumbnails();
            panel.classList.add('open');
        }
    }

    // Email gate
    function submitEmail() {
        console.log("Email gate");
        const email = document.getElementById('gateEmail').value;
        const name = "";
        if (!email || !email.includes('@')) {
            document.getElementById('gateEmail').style.borderColor = '#c0392b';
            return;
        }
        const nameParts = name.split(" ");
        const firstName = nameParts[0] || "";
        const lastName = nameParts.slice(1).join(" ") || "";
        const productName="Sprung Gym Flooring — Product Catalogue 2026";
        
        // Submit to Klaviyo
        try {
           
            fetch("https://a.klaviyo.com/client/subscriptions/?company_id=YxZeT5", {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              "revision": "2023-10-15"
                            },
                            body: JSON.stringify({
                              data: {
                                type: "subscription",
                                attributes: {
                                  profile: {
                                    data: {
                                      type: "profile",
                                      attributes: {
                                        email: email,
                                        first_name: firstName,
                                        last_name: lastName,
                                        properties: {
                                          product_catalogue: productName
                                        }
                                      }
                                    }
                                  }
                                },
                                relationships: {
                                  list: {
                                    data: {
                                      type: "list",
                                      id: "TUS3AU"
                                    }
                                  }
                                }
                              }
                            })
                          });
        } catch(e) {}
        
        skipGate();
    }

    function skipGate() {
        document.getElementById('emailGate').classList.add('hidden');
    }

    // Init
    updateScale();
    window.addEventListener('resize', updateScale);
    showPage(0);